import Bildebank from "./Bildebank";

export default Bildebank;
